<template>
  <div name="demo-calendar-worktime">
    <hrms-calendar-work-time />
  </div>
</template>

<script>
import hrmsCalendarWorkTime from 'components/hrmsCalendarWorkTime/component'

export default {
  name: 'demo-calendar-worktime',
  components: {
    hrmsCalendarWorkTime
  }
}
</script>


// WEBPACK FOOTER //
// demoCalendarWorktime.vue?267375ac